import React, { FC, useEffect } from "react";
import { Text } from "@/styles/reactnative";
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalHeader,
  ModalOverlay,
} from "./styles";
import { useIsMobile } from '@utils/CalVW.tsx';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';
import { useWindowDimensions } from "@/app/hooks";

type ModalProps = {
  visible: boolean;
  onClose: () => void;
  children?: any;
  title?: string;
  bgColor?: string;
  width?: string;
  isResponsive?: boolean;
};
const CModal: FC<ModalProps> = ({
  visible,
  onClose,
  children,
  title,
  bgColor,
  isResponsive = false,
  width
}) => {
  const isMobile = useIsMobile();

  useDisableScroll(visible);

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (visible) {
      // Disable scrolling on the window when the modal is open
      document.body.style.overflow = "hidden";
      // Re-enable scrolling when the modal is closed
      return () => {
        document.body.style.overflow = "visible";
      };
    }
  }, [visible]);
  const { width: w, height } = useWindowDimensions();

  const wSize =
    isResponsive ? (w > 1400 ? w / 3.4 : w > 1200 ? w / 2.8 : w > 1200 ? w / 2.2 : w / 2.2) : (isMobile ? '95%' : (width ? width : '800px'));

  return (
    <>
      {visible && (
        <ModalOverlay onClick={onClose}>
          <ModalContainer
            style={{ 
              // background: bgColor ? bgColor : "#fff", width: isMobile ? "95%" : width ? width : '800px'
              background: bgColor ? bgColor : "#fff", width: wSize, height: isResponsive ? height / 3.6 : 'auto', minHeight: 230
            }}
            onClick={(e) => e.stopPropagation()}
            onTouchMove={handleTouchMove}
          >
            {title ? (
              <ModalHeader>
                <Text
                  size={20}
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {title ? title : ""}
                </Text>
                <ModalCloseButton onClick={onClose}>x</ModalCloseButton>
              </ModalHeader>
            ) : null}

            <ModalBody>{children}</ModalBody>
          </ModalContainer>
        </ModalOverlay>
      )}
    </>
  );
};

export default React.memo(CModal);
// style={{width : isMobile ? '99%' : wSize, height: height / 3.6, minHeight: 230}}

// style={{ width: '100%' ,minHeight: 230}}
